module.exports = __webpack_public_path__ + "static/media/bg_green.32947853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_green.png
// module id = 656
// module chunks = 0